import { constructEnum } from '@/lib/enum';

export default constructEnum('VideoReviewsScope', {
  NONE: 0,
  ADMIN_ONLY: 1,
  ADMIN_AND_POPUP: 2
});
